const initializedSections = new WeakSet();

const isCurrentPageDestination = (link, section) => {
  const destination = new URL(link.href, window.location.href);
  const current = new URL(window.location.href);
  const destinationPath = destination.pathname.replace(/\/+$/, '') || '/';
  const currentPath = current.pathname.replace(/\/+$/, '') || '/';

  return (
    destination.origin === current.origin
    && (
      destinationPath === currentPath
      || (currentPath !== '/' && destinationPath.endsWith(currentPath))
    )
    && destination.search === current.search
    && destination.hash === `#${section.id}`
  );
};

const initContactNavigation = (scope = document) => {
  const sections = scope.querySelectorAll(
    '[data-contact-form-section][id], [data-global-contact-upload-section] form[id]'
  );

  sections.forEach((section) => {
    if (initializedSections.has(section)) {
      return;
    }

    initializedSections.add(section);

    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');

      if (
        !link
        || event.defaultPrevented
        || event.button !== 0
        || event.metaKey
        || event.ctrlKey
        || event.shiftKey
        || event.altKey
        || link.target
        || !isCurrentPageDestination(link, section)
        || typeof window.scrollToEl !== 'function'
      ) {
        return;
      }

      const headerOffset = document.querySelector('.header')?.offsetHeight ?? 0;

      event.preventDefault();
      window.scrollToEl(`#${section.id}|800|${headerOffset}`);
    });
  });
};

initContactNavigation();
window.initContactNavigation = initContactNavigation;
